import axios from "axios";
import { ServicesType } from "../Types/ServicesTypes";
import { BrandsTypes } from "../Types/BrandsTypes";

export type HoverItem = {
    id: number;
    title: string;
    image: string | null;
    navigate: string;
};

export type NavHoverData = {
    [key: string]: HoverItem[];
};

export const fetchNavHoverData = async (): Promise<NavHoverData> => {
    try {
        const [servicesResponse, brandsTypesResponse] = await Promise.all([
            axios.get('https://sazuli.pt/api/services'),
            axios.get('https://sazuli.pt/api/getAllBrands')
        ]);

        const servicesData = servicesResponse.data;
        const brandsTypesData = brandsTypesResponse.data;

        const navHoverData: NavHoverData = {
            servicos: servicesData.map((item: ServicesType, index: number) => ({
                id: item.ID,
                title: item.Title,
                image: item.Image,
                navigate: 'servicos'
            })),
            sazuli: [
                { id: 0, title: "Missão", image: "/assets/images/1.jpg", navigate: 'sazuli?missao' },
                { id: 0, title: "Visão", image: "/assets/images/1.jpg", navigate: 'sazuli?visao' },
                { id: 0, title: "Valores", image: "/assets/images/1.jpg", navigate: 'sazuli?valores' },
                { id: 1, title: "Compromisso", image: "/assets/images/3.jpg", navigate: 'sazuli?servicos' },
                { id: 2, title: "Equipa", image: "/assets/images/3.jpg", navigate: 'sazuli?equipa' },
            ],
            parceiros: brandsTypesData.map((item: BrandsTypes, index: number) => ({
                id: item.ID,
                title: item.Name,
                image: item.Image,
                navigate: 'parceiros?' + item.Name.replace(/\s+/g, '-').toLowerCase()
            })),
        };

        return navHoverData;

    } catch (err) {
        console.error("Failed to fetch nav hover data:", err);
        return {
            servicos: [],
            sazuli: [],
            parceiros: []
        };
    }
};
